// extracted by mini-css-extract-plugin
module.exports = {"panWrapper":"style_panWrapper__2x02_","container":"style_container__26AAT","title":"style_title__27Tl9"};